import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  folderId: string,
  name: string,
  level: number,
  parentId?: string,
  indexes?: number,
};

export class ApiPrintFavoriteFolderEdit extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      folderId,
      ..._param
    } = param;

    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/favfolder/${folderId}`,
      'JSON',
      _param,
    );
  }
}
